/**
 * Meta (Facebook) Pixel helper.
 *
 * Paste your Pixel ID in `metaPixelId` below (Events Manager → Data sources →
 * your pixel → the 15-16 digit number). Leave it empty to disable tracking,
 * which is useful while previewing the page.
 */
export const metaPixelId = ''

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

function loadPixelScript() {
  if (window.fbq) return

  const fbq: Fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue?.push(args)
    }
  } as Fbq

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)
}

/** Initializes the pixel and sends the initial PageView. */
export function initMetaPixel() {
  if (typeof window === 'undefined' || !metaPixelId) return

  loadPixelScript()
  window.fbq?.('init', metaPixelId)
  window.fbq?.('track', 'PageView')
}

/** Sends a standard Meta event, e.g. trackPixelEvent('InitiateCheckout'). */
export function trackPixelEvent(event: string, params?: Record<string, unknown>) {
  if (typeof window === 'undefined' || !metaPixelId) return
  window.fbq?.('track', event, params)
}
